import { TRANSACTION_CHECK_EXIST } from "../Corporate/List/action";

export const DOWNLOAD_EXCEL_FILE = 'src/Admin/Metering-System/action/Download_Excel_File';
export const DOWNLOAD_EXCEL_FILE_SUCCESS = 'src/Admin/Metering-System/action/Download_Excel_File_Success';
export const DOWNLOAD_EXCEL_FILE_FAILURE = 'src/Admin/Metering-System/action/Download_Excel_File_Failure';
export const METERING_SYSTEM_DATA = 'src/Admin/Metering-System/action/Metering_System_Data';
export const METERING_SYSTEM_DATA_SUCCESS = 'src/Admin/Metering-System/action/Metering_System_Data_Success';
export const METERING_SYSTEM_DATA_FAILURE = 'src/Admin/Metering-System/action/Metering_System_Data_Failure';
export const METERING_SYSTEM_EXCEL_DOWNLOAD = 'src/Admin/Metering-System/action/Metering_System_Excel_Download';
export const METERING_SYSTEM_EXCEL_DOWNLOAD_SUCCESS = 'src/Admin/Metering-System/action/Metering_System_Excel_Download_Success';
export const METERING_SYSTEM_EXCEL_DOWNLOAD_FAILURE = 'src/Admin/Metering-System/action/Metering_System_Excel_Download_Failure';
export const TRANSACTION_DATA_CHECK = 'src/Admin/Metering-System/action/Transaction_Data_Check';
export const TRANSACTION_DATA_CHECK_SUCCESS = 'src/Admin/Metering-System/action/Transaction_Data_Check_Success';
export const TRANSACTION_DATA_CHECK_FAILURE = 'src/Admin/Metering-System/action/Transaction_Data_Check_Failure';


export const downloadExcelFile = (data) => {
    return {
        type: DOWNLOAD_EXCEL_FILE,
        data
    }
}
export const downloadExcelFileSuccess = (data) => {
    return {
        type: DOWNLOAD_EXCEL_FILE_SUCCESS,
        data
    }
}
export const downloadExcelFileFailure = (data) => {
    return {
        type: DOWNLOAD_EXCEL_FILE_FAILURE,
        data
    }
}

export const meteringSystemData = (data) => {
    return {
        type: METERING_SYSTEM_DATA,
        data
    }
}
export const meteringSystemDataSuccess = (data) => {
    return {
        type: METERING_SYSTEM_DATA_SUCCESS,
        data
    }
}
export const meteringSystemDataFailure = (data) => {
    return {
        type: METERING_SYSTEM_DATA_FAILURE,
        data
    }
}

export const meteringSystemExcelDownload = (data) => {
    return {
        type: METERING_SYSTEM_EXCEL_DOWNLOAD,
        data
    }
}
export const meteringSystemExcelDownloadSuccess = (data) => {
    return {
        type: METERING_SYSTEM_EXCEL_DOWNLOAD_SUCCESS,
        data
    }
}
export const meteringSystemExcelDownloadFailure = (data) => {
    return {
        type: METERING_SYSTEM_EXCEL_DOWNLOAD_FAILURE,
        data
    }
}

export const transactionDataCheck = (data) => {
    return {
        type: TRANSACTION_DATA_CHECK,
        data
    }
}
export const transactionDataCheckSuccess = (data) => {
    return {
        type: TRANSACTION_DATA_CHECK_SUCCESS,
        data
    }
}
export const transactionDataCheckFailure = (data) => {
    return {
        type: TRANSACTION_DATA_CHECK_FAILURE,
        data
    }
}

export const UPLOAD_METERING_SYSTEM = 'src/Admin/Metering-System/action/Upload_Metering_System';
export const UPLOAD_METERING_SYSTEM_SUCCESS = 'src/Admin/Metering-System/action/Upload_Metering_System_success';
export const UPLOAD_METERING_SYSTEM_FAILURE = 'src/Admin/Metering-System/action/Upload_Metering_System_failure';

export const uploadMeteringSystemExcelFile = (data) => {
    return {
        type: UPLOAD_METERING_SYSTEM,
        data
    }
}
export const excelUploadMeteringSystemSuccess = (data) => {
    return {
        type: UPLOAD_METERING_SYSTEM_SUCCESS,
        data
    }
}
export const excelUploadMeteringSystemFailure = (data) => {
    return {
        type: UPLOAD_METERING_SYSTEM_FAILURE,
        data
    }
}

export const FETCH_MAIL_CONFIG = 'src/Admin/Metering-System/action/Fetch_Mail_Config';
export const FETCH_MAIL_CONFIG_SUCCESS = 'src/Admin/Metering-System/action/Fetch_Mail_Config_Success';
export const FETCH_MAIL_CONFIG_FAILURE = 'src/Admin/Metering-System/action/Fetch_Mail_Config_Failure';
export const SAVE_MAIL_CONFIG = 'src/Admin/Metering-System/action/Save_Mail_Config';
export const SAVE_MAIL_CONFIG_SUCCESS = 'src/Admin/Metering-System/action/Save_Mail_Config_Success';
export const SAVE_MAIL_CONFIG_FAILURE = 'src/Admin/Metering-System/action/Save_Mail_Config_Failure';

export const CHECK_AGREEMENT_STATUS = 'src/Admin/Metering-System/action/Check_Agreement_Status';
export const CHECK_AGREEMENT_STATUS_SUCCESS = 'src/Admin/Metering-System/action/Check_Agreement_Status_Success';
export const CHECK_AGREEMENT_STATUS_FAILURE = 'src/Admin/Metering-System/action/Check_Agreement_Status_Failure';

export const checkAgreementStatus = (data) => {
    return {
        type: CHECK_AGREEMENT_STATUS,
        data
    }
}
export const checkAgreementStatusSuccess = (data) => {
    return {
        type: CHECK_AGREEMENT_STATUS_SUCCESS,
        data
    }
}
export const checkAgreementStatusFailure = (data) => {
    return {
        type: CHECK_AGREEMENT_STATUS_FAILURE,
        data
    }
}

export const NOTIFY_SALES_ASSOCIATE = 'src/Admin/Metering-System/action/Notify_Sales_Associate';
export const NOTIFY_SALES_ASSOCIATE_SUCCESS = 'src/Admin/Metering-System/action/Notify_Sales_Associate_Success';
export const NOTIFY_SALES_ASSOCIATE_FAILURE = 'src/Admin/Metering-System/action/Notify_Sales_Associate_Failure';

export const notifySalesAssociate = (data) => {
    return {
        type: NOTIFY_SALES_ASSOCIATE,
        data
    }
}
export const notifySalesAssociateSuccess = (data) => {
    return {
        type: NOTIFY_SALES_ASSOCIATE_SUCCESS,
        data
    }
}
export const notifySalesAssociateFailure = (data) => {
    return {
        type: NOTIFY_SALES_ASSOCIATE_FAILURE,
        data
    }
}

export const fetchMailConfig = () => {
    return {
        type: FETCH_MAIL_CONFIG
    }
}
export const fetchMailConfigSuccess = (data) => {
    return {
        type: FETCH_MAIL_CONFIG_SUCCESS,
        data
    }
}
export const fetchMailConfigFailure = (data) => {
    return {
        type: FETCH_MAIL_CONFIG_FAILURE,
        data
    }
}
export const saveMailConfig = (data, id) => {
    return {
        type: SAVE_MAIL_CONFIG,
        data,
        id
    }
}
export const saveMailConfigSuccess = (data) => {
    return {
        type: SAVE_MAIL_CONFIG_SUCCESS,
        data
    }
}
export const saveMailConfigFailure = (data) => {
    return {
        type: SAVE_MAIL_CONFIG_FAILURE,
        data
    }
}